var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row no-gutter items-center justify-center"},[(_vm.currentStepComponent)?_c(_vm.currentStepComponent,{tag:"component",attrs:{"onboarding-step-data":_vm.onboardingStepData},on:{"updated":_vm.getInvestorOnboardingData}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }